import { gql, useMutation } from '@apollo/client'

interface LogoutData {
  logout: boolean
}

export const GQL_MUTATION_LOGOUT = gql`
  mutation Logout {
    logout
  }
`

export const useLogout = () =>
  useMutation<LogoutData>(GQL_MUTATION_LOGOUT)
